import { useLayoutEffect } from "react"
import { useUnit } from "effector-react"
import assetSidebars from "stores/assetSidebars"
import pendingAssetSidebarStore from "stores/pendingAssetSidebar"

/**
 * Global component that automatically handles pending asset sidebar requests
 * across all pages without requiring individual hook implementations.
 * 
 * This should be included once at the app level to provide automatic
 * sidebar opening behavior throughout the application.
 */
const GlobalAssetSidebarHandler = () => {
    const pendingAssetSidebar = useUnit(pendingAssetSidebarStore.$pendingAssetSidebar)

    useLayoutEffect(() => {
        if (pendingAssetSidebar.assetId) {
            // Small delay to ensure page has fully loaded and rendered
            const timeoutId = setTimeout(() => {
                assetSidebars.show({
                    assetId: pendingAssetSidebar.assetId!,
                    onReservationDelete: pendingAssetSidebar.onReservationDelete || (() => {})
                })
                pendingAssetSidebarStore.clearPendingAssetSidebar()
            }, 100)

            return () => clearTimeout(timeoutId)
        }
    }, [pendingAssetSidebar])

    // This component doesn't render anything visible
    return null
}

export default GlobalAssetSidebarHandler
